import { useTranslation } from "react-i18next";

import BaseTag from "@/components_v2/Tags/BaseTag";
import { TAG_VARIANTS } from "@/components_v2/Tags/constants";
import { getPathShortTitle } from "@/domains/certifications/utils";
import { PathTagProps } from "@/domains/certifications/components/types";

import "./styles.css";

const PATH_TAG_CLASSES: Record<string, string> = {
  participation: "path-tag-participation",
};

const PathTag = ({ certification, trackId }: PathTagProps) => {
  const { t } = useTranslation();
  const track = certification.tracks.find((item) => item.id === trackId);
  const label = getPathShortTitle(t, certification, trackId);
  if (!track || !label) {
    return null;
  }

  return (
    <BaseTag
      label={label}
      size="small"
      variant={TAG_VARIANTS.TINTED}
      className={PATH_TAG_CLASSES[track.slug]}
    />
  );
};

export default PathTag;
